const MS_PER_WEEK = 7 * 24 * 60 * 60 * 1000

/**
 * Week count from campaign start/end — same ceil math as Launching Screen "Week Timeline".
 * Returns null when dates are missing or invalid.
 */
export function campaignWeekTimelineCount(
  startDate: string | null | undefined,
  endDate: string | null | undefined,
): number | null {
  if (!startDate || !endDate) return null
  const start = new Date(startDate).getTime()
  const end = new Date(endDate).getTime()
  if (!Number.isFinite(start) || !Number.isFinite(end) || end <= start) return null
  return Math.max(1, Math.ceil((end - start) / MS_PER_WEEK))
}

/** Numeric string for Launching Screen "Week Timeline" value (or "—"). */
export function formatCampaignWeekTimelineValue(
  startDate: string | null | undefined,
  endDate: string | null | undefined,
): string {
  const weeks = campaignWeekTimelineCount(startDate, endDate)
  return weeks == null ? '—' : String(weeks)
}

/** Display for Preview "Instrument Timeline" (e.g. "2 Weeks"). */
export function formatInstrumentTimelineDisplay(
  startDate: string | null | undefined,
  endDate: string | null | undefined,
): string {
  const weeks = campaignWeekTimelineCount(startDate, endDate)
  if (weeks == null) return '—'
  return weeks === 1 ? '1 Week' : `${weeks} Weeks`
}
